var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-info" }, [
    _c("div", { staticClass: "form-row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.devcInspectFlowInfo.name))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-value",
          staticStyle: { width: "-webkit-calc(100% - 146px)" }
        },
        [_c("span", [_vm._v(_vm._s(_vm.devcInspectFlowInfo.feature))])]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.devcInspectFlowInfo.disabled ? "是" : "否"))
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.devcInspectFlowInfo.disabled
      ? _c("div", { staticClass: "form-row" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              staticStyle: { width: "-webkit-calc(100% - 146px)" }
            },
            [_c("span", [_vm._v(_vm._s(_vm.devcInspectFlowInfo.disableCause))])]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.devcInspectFlowInfo.creatorName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.devcInspectFlowInfo.createTime))])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-row",
        staticStyle: { height: "auto", overflow: "hidden" }
      },
      [
        _vm._m(6),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-value",
            staticStyle: { width: "-webkit-calc(100% - 146px)" }
          },
          [_c("span", [_vm._v(_vm._s(_vm.devcInspectFlowInfo.desc || "无"))])]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("流程名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("流程特点")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否禁用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("备注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e57bc08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e57bc08","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/rentServc/DevcInspectFlowInfo.vue
// module id = 1988
// module chunks = 1